import React, { Component } from "react";
import "./avatar.css";
import avatar from "../images/avatar.jpg";

export default class Avatar extends Component {
  render() {
    return (
      <div className="avatar-container">
        <div className="row justify-content-center mt-0">
          <img src={avatar} className="avatar" alt="avatar" />
        </div>
        <div className="socialicons d-flex justify-content-center justify-content-around pt-2">
          <a
            href="https://github.com/Thakur-Sahab-4-5-2000"
            target="_blank"
            rel="noreferrer"
            className="socialicon"
          >
            <span className="icon-github"></span>
          </a>
          <a
            href="https://www.instagram.com/____thakursaab_____/"
            target="_blank"
            rel="noreferrer"
            className="socialicon"
          >
            <span className="icon-instagram"></span>
          </a>
          <a
            href="https://www.facebook.com/Huntershikaaribro/"
            target="_blank"
            rel="noreferrer"
            className="socialicon"
          >
            <span className="icon-facebook-square"></span>
          </a>
        </div>
      </div>
    );
  }
}
